import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getErrorsSelector } from "../store/modules/api/selectors";

export function useErrors(key: string) {
  const selector = useMemo(() => getErrorsSelector(key), [key]);

  return useSelector(selector);
}
